import { render, staticRenderFns } from "./imgOrTextMaterial.vue?vue&type=template&id=f77397d0&scoped=true"
import script from "./imgOrTextMaterial.vue?vue&type=script&lang=js"
export * from "./imgOrTextMaterial.vue?vue&type=script&lang=js"
import style0 from "./imgOrTextMaterial.vue?vue&type=style&index=0&id=f77397d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77397d0",
  null
  
)

export default component.exports